import { render, staticRenderFns } from "./TagTable.vue?vue&type=template&id=2025e296"
import script from "./TagTable.vue?vue&type=script&lang=ts"
export * from "./TagTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports